// import React, { useState } from 'react';
// import { Row, Col, Input, Label, Button,Card, CardBody,CardHeader, CardTitle, } from 'reactstrap';
// import { CardContent} from "@material-ui/core"
// import Axios from 'axios';
// import { toast } from 'react-toastify';
// import { useHistory } from "react-router-dom";


// const ContactUs=()=>{
//   let history = useHistory();
//   const [firstname, setfirstname] = useState('');
//   const [email, setemail] = useState('');
//   const [phoneno, setphoneno] = useState('');
//   const [query, setquery] = useState('');
//   const handleSubmit = async ()=>{
//       console.log({firstname,email,phoneno,query})
//       if (firstname == ''  || email == '' || phoneno == '' || query == '') {
//         toast.error('All fields are required');
//       } else {
        
//         try {
//           const res = await Axios({
//             method: 'POST',
//             url: process.env.REACT_APP_PORT + `/api/me/query`,
//             data: { Source:"Mergecall",firstname, email, phoneno, query },
//             headers: {
//               'x-auth-token': localStorage.getItem('token')
//             }
//           });
//           console.log('datttaaa', res.data);
//           toast.success("Thanks. We will get back to you shortly!")
//           history.push("/");
          
          
          
  
//         } catch (e) {
//           toast.error(e?.response?.data?.error);
//         }
//       }

//   }
//   return (
//     <div className="container">
//       <Card style={{width:'55vw',color: "#424242"}} className="container">
//           <CardHeader>
//           <CardTitle>
//               <Label>
//               <img className="mr-2" style={{marginBottom:"36px"}} src={"/logo128.png"} alt="Logo" width={"60px"} />
//         <span style={{fontSize:"2.95rem",color:"#2c7be5"}}>ergeCall</span>
//               </Label>
//               <p>We'd love to hear from you.</p>
//               <p>Please fill in the form below so that we can get more insights of what you are looking for and we can take things from there!</p>
              
              
//               <Card>
            
//             <CardBody className="pt-1">
//               <Row>
//                 <Col xs="6">
//                   <Label style={{fontSize:"1rem",color:"#2c7be5"}}>Canada Office</Label>
//                   <p>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
//                 </Col>
//                 <Col xs="6">
//                   <Label style={{fontSize:"1rem",color:"#2c7be5"}}>US Office</Label>
//                   <p>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
//                 </Col>
//               </Row>
//             </CardBody>
//           </Card>
//               {/* <p>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
//               <p>© 2021 mergecall.com, Inc C Corp, Newark, DE, United States</p> */}
//           </CardTitle>
//           </CardHeader>
          
//     <CardBody>
          
//       <Row className="p-2">
//         <Col >
//           <Label>First Name</Label>
//           <Input
//             type="text"
//             onChange={({ target }) => setfirstname(target.value)}
//             placeholder="firstname"
//             value={firstname}
//           />
//         </Col>
//       </Row>

//       <Row className="p-2">
//         <Col>
//           <Label>Email</Label>
//           <Input type="email" onChange={({ target }) => setemail(target.value)} placeholder="Email" value={email} />
//         </Col>
//       </Row>
//       <Row className="p-2">
//         <Col>
//           <Label>Phone number</Label>
//           <Input
//             type="text"
//             onChange={({ target }) => setphoneno(target.value)}
//             placeholder="Phone number"
//             value={phoneno}
//           />
//         </Col>
//       </Row>

//       <Row className="p-2">
//         <Col >
//           <Label>Your query</Label>
//           <Input
//             type="textarea"
//             onChange={({ target }) => setquery(target.value)}
//             placeholder="Query"
//             value={query}
//           />
//         </Col>
//       </Row>
//       <Row className='p-2 justify-content-center'>
//         <Col md={{ size: 3 }}>
//           <Button  color="primary" block className="mt-3" onClick={handleSubmit}>
//            Submit
//           </Button>
//         </Col>
//       </Row>
//       </CardBody>
//       <div></div>
//       <Row className=' justify-content-center' >
//         <Col md={{ size: 8 }}>
          
//         <p style={{textAlign: "center",fontSize: "1.5rem",color:"#2c7be5"}}>Support <i class="material-icons">phone</i> +1 415-417-0410</p>
//           <p  style={{textAlign: "center"}}>© 2022 mergecall.com, Inc C Corp</p>
//           <p  style={{textAlign: "center"}}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
//           <p  style={{textAlign: "center"}}>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
//         </Col>
//       </Row>
//       {/* <p className="container">Support <i class="material-icons">phone</i> +1 415-417-0410</p> */}
//       </Card>
//     </div>
//   );
// }

// export default ContactUs;


import React, { useState } from 'react';
import { Row, Col, Input, Label, Button, Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";

const ContactUs = () => {
  let history = useHistory();
  const [firstname, setfirstname] = useState('');
  const [email, setemail] = useState('');
  const [phoneno, setphoneno] = useState('');
  const [query, setquery] = useState('');

  const handleSubmit = async () => {
    if (firstname === '' || email === '' || phoneno === '' || query === '') {
      toast.error('All fields are required');
    } else {
      try {
        const res = await Axios({
          method: 'POST',
          url: process.env.REACT_APP_PORT + '/api/me/query',
          data: { Source: "Mergecall", firstname, email, phoneno, query },
          headers: {
            'x-auth-token': localStorage.getItem('token')
          }
        });
        toast.success("Thanks. We will get back to you shortly!");
        history.push("/");
      } catch (e) {
        toast.error(e?.response?.data?.error);
      }
    }
  };

  return (
    <div className="container" style={{ maxWidth: '600px', margin: '0 auto', padding: '20px', backgroundColor: '#fff', borderRadius: '15px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      {/* <Card style={{ border: 'none' }}> */}

        <CardHeader style={{ padding: '20px 30px', textAlign: 'center' }}>
          <h2 style={{ color: '#2c7be5' }}><img className="mr-2" style={{ marginBottom: "20px" }} src="/logo128.png" alt="Logo" width="50px" />
          ergeCall</h2>
          <p style={{ fontSize: '1rem', color: '#424242' }}>We'd love to hear from you.</p>
          <p style={{ fontSize: '0.9rem', color: '#424242' }}>
            Please fill in the form below so that we can get more insights into what you are looking for and we can take things from there!
          </p>
        </CardHeader>

        <CardBody style={{ padding: '30px' }}>
          {/* <Row className="mb-3">
            <Col xs="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' ,marginRight:'5px'}}>
              <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>Canada Office</Label>
              <p style={{ fontSize: '0.9rem' }}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
            </Col>
            <Col xs="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' ,marginLeft:'5px'}}>
              <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>US Office</Label>
              <p style={{ fontSize: '0.9rem' }}>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
            </Col>
          </Row> */}

{/* <Row style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
  <Col xs="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>Canada Office</Label>
    <p style={{ fontSize: '0.9rem' }}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
  </Col>
  <Col xs="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>US Office</Label>
    <p style={{ fontSize: '0.9rem' }}>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
  </Col>
</Row> */}

{/* <Row style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
  <Col xs="12" sm="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>Canada Office</Label>
    <p style={{ fontSize: '0.9rem' }}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
  </Col>
  <Col xs="12" sm="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>US Office</Label>
    <p style={{ fontSize: '0.9rem' }}>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
  </Col>
</Row> */}

{/* <Row style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', flexWrap: 'nowrap' }}>
  <Col xs="12" sm="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>Canada Office</Label>
    <p style={{ fontSize: '0.9rem' }}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
  </Col>
  <Col xs="12" sm="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>US Office</Label>
    <p style={{ fontSize: '0.9rem' }}>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
  </Col>
</Row> */}

<Row style={{ display: 'flex', justifyContent: 'space-between', gap: '10px',   flexWrap: window.innerWidth < 768 ? 'wrap' : 'nowrap',  }}>
  <Col xs="12" sm="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px', wordWrap: 'break-word' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>Canada Office</Label>
    <p style={{ fontSize: '0.9rem' }}>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
  </Col>
  <Col xs="12" sm="6" style={{ backgroundColor: '#f2f7ff', padding: '15px', borderRadius: '10px', wordWrap: 'break-word' }}>
    <Label style={{ fontSize: "1rem", color: "#2c7be5" }}>US Office</Label>
    <p style={{ fontSize: '0.9rem' }}>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p>
  </Col>
</Row>

<br></br>

          <Row className="p-2">
            <Col>
              {/* <Label>First Name</Label> */}
              <Input
                type="text"
                onChange={({ target }) => setfirstname(target.value)}
                placeholder="First name"
                value={firstname}
                style={{ borderRadius: '10px', padding: '10px', border: '1px solid #ccc' }}
              />
            </Col>
          </Row>

          <Row className="p-2">
            <Col>
              {/* <Label>Email</Label> */}
              <Input
                type="email"
                onChange={({ target }) => setemail(target.value)}
                placeholder="Email"
                value={email}
                style={{ borderRadius: '10px', padding: '10px', border: '1px solid #ccc' }}
              />
            </Col>
          </Row>

          <Row className="p-2">
            <Col>
              {/* <Label>Phone number</Label> */}
              <Input
                type="text"
                onChange={({ target }) => setphoneno(target.value)}
                placeholder="Phone number"
                value={phoneno}
                style={{ borderRadius: '10px', padding: '10px', border: '1px solid #ccc' }}
              />
            </Col>
          </Row>

          <Row className="p-2">
            <Col>
              {/* <Label>Your query</Label> */}
              <Input
                type="textarea"
                onChange={({ target }) => setquery(target.value)}
                placeholder="Your query"
                value={query}
                style={{ borderRadius: '10px', padding: '10px', border: '1px solid #ccc' }}
              />
            </Col>
          </Row>

          <Row className='p-2 justify-content-center'>
            <Col md={{ size: 3 }}>
              <Button
                color="primary"
                block
                className="mt-3"
                onClick={handleSubmit}
                style={{ borderRadius: '10px', backgroundColor: '#2c7be5', padding: '7px 12px', fontSize: '1rem' }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </CardBody>

        <Row className="justify-content-center" style={{ padding: '20px 0', textAlign: 'center' }}>
          <Col md={{ size: 8 }}>
            {/* <p style={{ fontSize: "1.5rem", color: "#2c7be5" }}>Support <i className="material-icons" style={{ fontSize: '1.5rem' }}>phone</i> +1 415-417-0410</p> */}
            <p
  style={{ fontSize: "1rem", color: "#2c7be5", cursor: "pointer" }}
  onClick={() => {
    navigator.clipboard.writeText("+14154170410").then(() => {
      // alert("Phone number copied to clipboard!");
      toast.success("Phone number copied to clipboard!");
      console.log("Phone number copied to clipboard!");

    }).catch((err) => {
      console.error("Failed to copy: ", err);
    });
  }}
>
  Support <i className="material-icons" style={{ fontSize: '1rem' }}>phone</i> +14154170410
</p>
            <p>© 2022 call.mergeasy.com, Inc C Corp</p>
            {/* <p>325 Front St W, Toronto, ON M5V 2Y1, Canada</p>
            <p>2035 Sunset Lake Rd SUITE B2, Newark, DE 19702, United States</p> */}
          </Col>
        </Row>
      {/* </Card> */}
    </div>
  );
}

export default ContactUs;
